module.exports = __webpack_public_path__ + "static/media/worldwide.466581a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/icons/flg/worldwide.svg
// module id = 175
// module chunks = 0